// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-title[data-v-25f5d178]{font-weight:900}.el-submenu[data-v-25f5d178]{margin:20px 0!important}", ""]);
// Exports
module.exports = exports;
